import { AlertOctagon } from 'lucide-react'
import { useGuardrail } from '@/hooks/useGuardrail'

/**
 * KillSwitchBanner is a sticky bottom-of-viewport red banner that lights up
 * whenever the global kill switch is active. Mounted in the shared Layout so
 * it shows on every authenticated route.
 *
 * The hook polling interval (15s) is the system-wide guardrail refresh rate;
 * matches what the dedicated /guardrail page uses, so both views stay in sync.
 */
export default function KillSwitchBanner() {
  const { data } = useGuardrail()
  if (!data?.kill_switch?.active) return null
  const reason = data.kill_switch.reason || 'no reason provided'
  const mode = data.kill_switch.mode || 'manual'
  return (
    <div
      role="alert"
      className="fixed bottom-0 inset-x-0 z-40 bg-red-700 text-white px-4 py-2 flex items-center gap-2 shadow-lg"
    >
      <AlertOctagon size={18} aria-hidden="true" />
      <span className="font-semibold">KILL SWITCH ACTIVE</span>
      <span className="opacity-90">— {reason}</span>
      <span className="ml-auto text-xs uppercase tracking-wide bg-red-900/60 rounded px-2 py-0.5">
        {mode}
      </span>
    </div>
  )
}
